import { CustomerNotificationCallToActions } from '../../../../gql/generated/graphql';
import FrozenOrLockedCreditNotificationModal from './FrozenOrLockedCreditNotificationModal';

interface Props {
  openNotificationModal: string | null;
  onClose: () => void;
}

const NotificationModals = ({ openNotificationModal, onClose }: Props) => {
  return (
    <FrozenOrLockedCreditNotificationModal
      isOpen={
        openNotificationModal === CustomerNotificationCallToActions.OpenFrozenOrLockedCreditModal
      }
      onClose={onClose}
    />
  );
};

export default NotificationModals;
